import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PromotionsService } from '../../promotions.service';
import {Location} from '@angular/common'; 
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

@Component({
  selector: 'app-update-festival',
  templateUrl: './update-festival.component.html',
  styleUrls: ['./update-festival.component.scss']
})
export class UpdateFestivalComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  createFestivalForm: FormGroup;
  countries: Array<any>;
  previousUrl: string;
  festivalId: any;
  festivalDetails: any;
  selectedcountry: any;
  minDate: Date = new Date();


  constructor(private activeRoute: ActivatedRoute,private _location: Location, private fb: FormBuilder, private router: Router, public dialog: MatDialog, private promotionsService: PromotionsService, private toastr:ToastrService) {
    super();
    this.festivalId =this.activeRoute.snapshot.params.id;
    this.promotionsService.getCarrierCountries().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        this.countries = resData.data;
      }
    })
  }

  private initForm() {
    this.createFestivalForm = new FormGroup({
      occassionName: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      country: new FormControl('', [Validators.required]),
      occationStartdttm: new FormControl('', [Validators.required]),
      occassionEnddttm: new FormControl('', [Validators.required])
    })
  }

  get f() {
    return this.createFestivalForm.controls;
  }


  ngOnInit(): void {
    super.ngOnInit()
    this.createFestivalForm = new FormGroup({
      occassionName: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      country: new FormControl('', [Validators.required]),
      occationStartdttm: new FormControl('', [Validators.required]),
      occassionEnddttm: new FormControl('', [Validators.required])
    })
    if (this.festivalId && this.festivalId) {
     
      this.promotionsService.getfestival(this.festivalId).subscribe(
        res => {
          let data: any = res;
          this.festivalDetails = data.data;
         
          this.selectedcountry = this.festivalDetails.country;
          this.createFestivalForm.get('occassionName').setValue(this.festivalDetails.occassionName),
          this.createFestivalForm.get('country').setValue(this.festivalDetails.country),
          this.createFestivalForm.get('occationStartdttm').setValue(moment(this.festivalDetails.occationStartdttm).format()),
          this.createFestivalForm.get('occassionEnddttm').setValue(moment(this.festivalDetails.occassionEnddttm).format())
        })
    }
  }
  onCancel() { 
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigate(['features/promotions/ocassion-rewards/festival-promo']);
      }
    });    
  }
  onSubmit() {
   
    if (this.createFestivalForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.createFestivalForm)
        }else{
          this.router.navigate(['features/promotions/ocassion-rewards/festival-promo']);
        }
      });

    }
  }
  setSubmitParameters(createFestivalForm: FormGroup) {

    let httpParams: Params = {
      occasionId: Number(this.festivalId),
      occassionName: createFestivalForm.get('occassionName').value,
      country: createFestivalForm.get('country').value,
      occationStartdttm: moment(createFestivalForm.get('occationStartdttm').value).format('MM-DD-YYYY'),
      occassionEnddttm: moment(createFestivalForm.get('occassionEnddttm').value).format('MM-DD-YYYY'),
      
    }
    //

    this.promotionsService.updatefestival(httpParams).subscribe(res => {
      if (res && res) { //alert("h3"); 
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
          this.router.navigate(['features/promotions/ocassion-rewards/festival-promo'])
          this.toastr.success('Festival added successfully', 'Success', {
            timeOut: 3000,
          });        
        }
      }
    });
  }

  
  ngOnDestroy() {
    super.ngOnDestroy()
  }
}